import { DateInputValue } from "basis";
import { OptionsValues } from "components/types";
import { ActionMap } from "library/ActionMap";
import { AccountInfo } from "library/hooks/types";
import { yesNoOptions } from "library/sharedOptions";
import { MakeRequired } from "library/utils";

export enum PAGES {
  FORM = "FORM",
  SUCCESS = "SUCCESS",
}

export enum ActionType {
  FORM_SUBMITTED = "FORM_SUBMITTED",
  ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED",
}

export type ScreenComponentType = React.FC<ScreenProps>;
export type PageInfo = {
  [key: string]: {
    heading: string;
    screenComponent: ScreenComponentType;
  };
};

export type FormValues = {
  firstName: string;
  lastName: string;
  dateOfBirth: DateInputValue;
  mobileNumber: string;
  travelStartDate: DateInputValue;
  countryOfDestination: string;
  additionalCardHolders: OptionsValues<typeof yesNoOptions>;
  travelEndDate: DateInputValue;
  additionalCards: {
    [key: string]: { cardNumber: string };
  };
};

export type State = {
  accountInfo?: AccountInfo;
  page: PAGES;
};

export type Payloads = {
  [ActionType.FORM_SUBMITTED]: undefined;
  [ActionType.ACCOUNT_INFO_LOADED]: {
    accountInfo: AccountInfo;
  };
};

export type Action = ActionMap<ActionType, Payloads>;

export interface GetOverseasTravelParams extends FormValues {
  userName: string;
  email: string;
  token: string;
}

export type ScreenState = MakeRequired<State, "accountInfo">;

export type ScreenProps = {
  state: ScreenState;
  dispatch: React.Dispatch<Action>;
};
